import { createContext } from './contextFactory'
import { ConfigDataModel } from '../types'

type _setBoolean = (value: boolean) => void

export const [InProgressContext, InProgressProvider] = createContext<_setBoolean>()
export const [ConfigContext, ConfigProvider] = createContext<ConfigDataModel>()
